import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;

export const ContentWrapper = styled.div`
  display: grid;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    padding: 0 10px;
  }
`;

export const ContainerItems = styled.div`
  max-width: 1240px;
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 20px;
`;

export const Label = styled.span`
  font-size: 36px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const Desc = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const Items = styled.div`
  z-index: 0;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 24px;
  column-gap: 40px;
  & > div {
    all: revert;
  }
  @media ${`(max-width: 960px)`} {
    grid-template-columns: 1fr;
    gap: 16px 0;
    margin-bottom: 20px;
  }
`;

export const LoadMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;
export const LoadMoreButton = styled.button`
  padding: 18px 40px;
  cursor: pointer;
  border-radius: 8px;
  border: solid 1px ${(p) => p.theme.palette.eclipse};
  background-color: white;
  width: 220px;
`;
